import './BlackCases.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';


export default function BlackCases() {
    const { t, i18n } = useTranslation();
    const casesBlocks = [{header: t('$Training_1'), tag: t('$Tr_sub_1'), link: 'https://best-practices.zenclass.ru/public/product/c0ac26fa-2635-4d8a-b0d0-1c6cfc03a17c/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_1')},
                        {header: t('$Training_2'), tag: t('$Tr_sub_2'), link: 'https://best-practices.zenclass.ru/public/product/8cb348e0-a241-4c0e-a643-c75702238a08/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_2')},
                        {header: t('$Training_3'), tag: t('$Tr_sub_3'), link: 'https://best-practices.zenclass.ru/public/product/f2e591d6-c1d2-49ba-a89d-aeea262b531e/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_3')},
                        {header: t('$Training_4'), tag: t('$Tr_sub_4'), link: 'https://best-practices.zenclass.ru/public/product/2c5164bf-c1f7-49e0-a0a3-4cf1c37e981a/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_4')},
                        {header: t('$Training_5'), tag: t('$Tr_sub_5'), link: 'https://best-practices.zenclass.ru/public/product/d23ac5f3-6f7f-4054-bc93-f644ecf7e19f/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_5')},
                        {header: t('$Training_6'), tag: t('$Tr_sub_6'), link: 'https://best-practices.zenclass.ru/public/product/a616398d-c66e-4c23-8e45-2757ce4c5d10/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_6')},
                        {header: t('$Training_7'), tag: t('$Tr_sub_7'), link: 'https://best-practices.zenclass.ru/public/product/56809ca5-0cc7-4e6d-9111-adcd08b6a143/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_7')},
                        {header: t('$Training_8'), tag: t('$Tr_sub_8'), link: 'https://best-practices.zenclass.ru/public/product/d0f5cad9-8e29-4fb0-83d9-023024b60d11/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_8')},
                        {header: t('$Training_9'), tag: t('$Tr_sub_9'), link: 'https://best-practices.zenclass.ru/public/product/2190a45a-c5de-4de4-ac6e-5a68f36d07b6/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_9')},
                        {header: t('$Training_10'), tag: t('$Tr_sub_10'), link: 'https://best-practices.zenclass.ru/public/product/08e798c7-079d-4548-a021-3a9d8e6194d2/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_10')},
                        {header: t('$Training_11'), tag: t('$Tr_sub_11'), link: 'https://best-practices.zenclass.ru/public/product/77cec0fb-96e4-4225-a2e1-afbafffe9955/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_11')},
                        {header: t('$Training_12'), tag: t('$Tr_sub_12'), link: 'https://best-practices.zenclass.ru/public/product/631dc4fd-8c10-4cd4-b70d-60d23d9b6cb1/tariffs?redirect_from_tariff=/public/products', content: t('$Tr_desc_12')}
    ];
    const url =
    'https://best-practices.zenclass.ru/public/products?redirect=%2Fschool%2Fproducts';

    const handleClick = () => {
        window.open(url, '_blank', 'noopener');
    };

    return(
        <section className='black-cases-section'>
            <div style={{position: 'absolute', inset: '0', width: '100%', height: '100%', pointerEvents: 'none', }}>
            <div style={{position: 'absolute', overflow: 'hidden', zIndex: '0', inset: '0'}}>
                <div style={{display:'flex', position:'relative', width: '100%', height: '100%', borderColor: 'hsl(var(--border))'}}>
                    <div className='black-cases-left-colored'>
                        <div style={{backgroundColor: 'rgba(20, 20, 20, 1.00)', maskImage: 'linear-gradient(0deg,#fff,#0000)', width: '100%', height: '10rem', zIndex:'20', left: '0', bottom: '0', position: 'absolute'}}>
                        </div>
                    </div>
                    <div className='black-cases-right-colored'>
                        <div style={{backgroundColor: 'rgba(20, 20, 20, 1.00)', maskImage: 'linear-gradient(0deg,#fff,#0000)', width: '100%', height: '10rem', zIndex:'20', left: '0', bottom: '0', position: 'absolute'}}>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div className="black-cases-content">
                <h1 style={{color: 'white', fontWeight: '500', fontSize: '2.2rem', margin: '0', marginTop: '160px', background: 'linear-gradient(90deg, #3466F8 5%, #CF4EE6 15%, #F6275D 40%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'}}>
                    {t('$LearnCourse')}
                </h1>
                <div className="black-cases-content-descr">
                    <p>
                        {t('$LinkBook')}
                    </p>
                    <button className='cases-title-bttn' onClick={handleClick}>
                        {t('$Buttom2-1')}
                    </button>
                </div>
                <div className='case-blocks'>
                <div className='case-blocks-row'>
                    {casesBlocks.map((block, idx) => (
                    <div className="case-blocks-row-content" key={idx}>
                        <h1>{block.header}</h1>
                        <p className="case-tag">{block.tag}</p>
                        <p className="case-content">{block.content}</p>
                        <a href={block.link} target="_blank" rel="noopener noreferrer" >
                            <p className='case-more'>
                                {t('$linktoClass')}
                            </p>
                        </a>
                        </div>
                    ))}
                </div>
                </div>
                <p style={{color: 'white', fontSize: '2.2rem', fontWeight: '500', margin: '40px auto', maxWidth: '450px', textAlign: 'center'}}>
                    {t('$Header4')}
                </p>
            </div>
            
        </section>
    );
}